import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { formatTimestampToPortalTz } from 'flow-doctor-lib/utils/dateTimeUtils';
import BranchMetLabel from 'flow-doctor-lib/components/actions/BranchMetLabel';
import ListBranchDebugSummaryRow from 'flow-doctor-lib/components/actions/ListBranchDebugSummaryRow';
import ListBranchDebugFilterBranchList from 'flow-doctor-lib/components/actions/ListBranchDebugFilterBranchList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ListBranchDebugContainer = ({
  logEvent,
  revision
}) => {
  const branchConnectionsForAction = revision.flow.actions[logEvent.action.actionId].connection.listBranches;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tile, {
      compact: true,
      padding: "0",
      distance: "flush",
      children: /*#__PURE__*/_jsxs(TileSection, {
        children: [/*#__PURE__*/_jsx(ListBranchDebugSummaryRow, {
          dataTestId: "list-branch-debug-panel-action-id",
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.listBranchDebugPanel.actionId"
          }),
          value: logEvent.action.actionId
        }), /*#__PURE__*/_jsx(ListBranchDebugSummaryRow, {
          dataTestId: "list-branch-debug-panel-executed-on",
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.listBranchDebugPanel.executedOn"
          }),
          value: formatTimestampToPortalTz(logEvent.timestamp)
        }), /*#__PURE__*/_jsx(ListBranchDebugSummaryRow, {
          dataTestId: "list-branch-debug-panel-total-branches",
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.listBranchDebugPanel.totalBranches"
          }),
          value: branchConnectionsForAction && branchConnectionsForAction.length
        }), /*#__PURE__*/_jsx(ListBranchDebugSummaryRow, {
          dataTestId: "list-branch-debug-panel-branch-met",
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.listBranchDebugPanel.branchMet"
          }),
          value: /*#__PURE__*/_jsx(BranchMetLabel, {
            logEvent: logEvent
          })
        })]
      })
    }), /*#__PURE__*/_jsx(ListBranchDebugFilterBranchList, {
      branchConnectionsForAction: branchConnectionsForAction,
      logEvent: logEvent
    })]
  });
};
export default ListBranchDebugContainer;